import { useState, useEffect } from "react";
import { IonToast } from "@ionic/react";
import { onToast } from "../lib/toast";

export default function AppToast() {
  const [toast, setToast] = useState<{ message: string; color: string; duration: number } | null>(null);

  useEffect(() => {
    return onToast((event) => {
      setToast({ message: event.message, color: event.color ?? "danger", duration: event.duration ?? 3000 });
    });
  }, []);

  return (
    <IonToast
      isOpen={!!toast}
      message={toast?.message}
      color={toast?.color}
      duration={toast?.duration}
      onDidDismiss={() => setToast(null)}
      position="top"
    />
  );
}
